import React, { useState } from "react";
import { Anchor, Drawer, Button } from "antd";

const { Link } = Anchor;

function AppHeader() {
  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <div className="container-fluid">
      <div className="header">
        <div className="logo">
          <i className="fas fa-bolt"></i>
          <a href="https://reintechconsulting.com">REINTECH Consulting</a>
        </div>
        <div className="mobileHidden">
          <Anchor targetOffset="65">
            <Link href="#home" title="Inicio" />
            <Link href="#about" title="Nosotros" />
            <Link href="#service" title="Servicios" />
            <Link href="#clients" title="Clientes" />
            <Link href="#faq" title="FAQ" />
            <Link href="#contact" title="Contacto" />
          </Anchor>
        </div>
        <div className="mobileVisible">
          <Button type="primary" onClick={showDrawer} style={{ "borderColor": "#19c95d", background: "#19c95d"}}>
            <i className="fas fa-bars"></i>
          </Button>
          <Drawer
            placement="right"
            closable={false}
            onClose={onClose}
            visible={visible}
          >
            <Anchor targetOffset="65">
              <Link href="#home" title="Inicio" />
              <Link href="#about" title="Nosotros" />
              <Link href="#service" title="Servicios" />
              <Link href="#clients" title="Clientes" />
              <Link href="#faq" title="FAQ" />
              <Link href="#contact" title="Contacto" />
            </Anchor>
          </Drawer>
        </div>
      </div>
    </div>
  );
}

export default AppHeader;
